var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#777777"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11798_37597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4246 25.8391C23.3697 26.4361 22.2044 26.8124 20.9996 26.9451V31.0001H18.9996V26.9451C16.9707 26.7176 15.0794 25.8075 13.6358 24.3639C12.1921 22.9203 11.282 21.0289 11.0546 19.0001H13.0696C13.2255 20.0795 13.6314 21.1075 14.2549 22.0023C14.8784 22.8971 15.7023 23.6339 16.661 24.1539C17.6197 24.6739 18.6865 24.9628 19.7766 24.9976C20.8666 25.0323 21.9498 24.812 22.9396 24.3541L21.3886 22.8041C20.6438 23.0194 19.8591 23.0587 19.0965 22.9186C18.3339 22.7786 17.6144 22.4631 16.9947 21.9972C16.375 21.5312 15.8721 20.9275 15.5259 20.2338C15.1796 19.5401 14.9995 18.7754 14.9996 18.0001V16.4141L9.39258 10.8081L10.8076 9.39305L30.6066 29.1931L29.1916 30.6071L24.4246 25.8391ZM27.3746 23.1601L25.9316 21.7181C26.4406 20.9081 26.7876 19.9881 26.9286 19.0001H28.9446C28.7795 20.4967 28.2395 21.9275 27.3746 23.1601ZM24.4646 20.2511L15.6846 11.4711C16.2395 10.5232 17.091 9.78439 18.1077 9.3688C19.1244 8.95322 20.2497 8.88397 21.3096 9.17175C22.3696 9.45953 23.3053 10.0883 23.9723 10.961C24.6392 11.8337 25.0002 12.9017 24.9996 14.0001L25.0006 18.0001C25.0017 18.7819 24.8188 19.553 24.4666 20.2511H24.4646Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11798_37597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableMicIcon);
export default __webpack_public_path__ + "static/media/disable-mic-icon.dd33eec094412de27b6913e4de92f2d5.svg";
export { ForwardRef as ReactComponent };